export default "__VITE_ASSET__060c9312__"